import useToken from "./useToken";

export default useIsLoggedIn;

function useIsLoggedIn(): boolean {
  const token = useToken();
  return token !== undefined;
}
